<template>
    <div style="height: 100%;">
        <div class="donnees">
            <div>{{ $t("_veillez_enter_les_donnees_de_production_") }} (.csv) (*)</div>
            <div class="attachFiles">
                <input id="input1" accept=".csv" multiple type="file" @change="handleFileChange($event, 'prod')">
                <label id="labelInput" class="file-chip" for="input1"> {{ $t('_choisir_un_fichier_') }}</label>
                <br>
                <label v-if="badFileFormat.prod" style="color: red;">{{ $t('_choisir_un_fichier_csv_') }}</label>
                <span id="fileName" v-for="(file, index) in donnees.anciennesDonnees.prod" :key="index">
                    <span v-if="visibleFiles(donnees.anciennesDonnees.prod).includes(file)" >
                    {{ file.filename }}
                    <v-icon style="font-size: medium;" @click="removeOld(index, 'prod')"> mdi-close</v-icon>
                    <br />
                    </span>
                </span>
                <span id="fileName" v-for="(file, index) in donnees.nouvelleDonnees.prod.value" :key="index">
                    {{ file.name }}
                    <v-icon style="font-size: medium;" @click="remove(index, 'prod')"> mdi-close</v-icon>
                    <br />
                </span>
            </div>
        </div>

        <div class="donnees">
            <div>{{ $t("_veillez_enter_les_donnees_meteorologiques_satellitaires_") }} (.csv)</div>
            <div class="attachFiles">
                <input id="input2" accept=".csv" multiple type="file"
                    @change="handleFileChange($event, 'meteoSatellites')">
                <label id="labelInput" class="file-chip" for="input2"> {{ $t('_choisir_un_fichier_') }}</label>
                <br>
                <label v-if="badFileFormat.meteoSatellites" style="color: red;">{{ $t('_choisir_un_fichier_csv_') }}</label>
                <span id="fileName" v-for="(file, index) in donnees.anciennesDonnees.meteoSatellites" :key="index">
                    <span v-if="visibleFiles(donnees.anciennesDonnees.meteoSatellites).includes(file)" >
                    {{ file.filename }}
                    <v-icon style="font-size: medium;" @click="removeOld(index, 'meteoSatellites')"> mdi-close</v-icon>
                    <br />
                    </span>
                </span>
                <span id="fileName" v-for="(file, index) in donnees.nouvelleDonnees.meteoSatellites.value"
                    :key="index">
                    {{ file.name }}
                    <v-icon style="font-size: medium;" @click="remove(index, 'meteoSatellites')"> mdi-close</v-icon>
                    <br />
                </span>
            </div>
        </div>
        <div class="donnees">
            <div>{{ $t("_veillez_enter_les_donnees_meteorologiques_in_situ_") }} (.csv)</div>
            <div class="attachFiles">
                <input id="input3" accept=".csv" multiple type="file" @change="handleFileChange($event, 'meteoInSitu')">
                <label id="labelInput" class="file-chip" for="input3"> {{ $t('_choisir_un_fichier_') }}</label>
                <br>
                <label v-if="badFileFormat.meteoInSitu" style="color: red;">{{ $t('_choisir_un_fichier_csv_') }}</label>
                <span id="fileName" v-for="(file, index) in donnees.anciennesDonnees.meteoInSitu" :key="index">
                    <span v-if="visibleFiles(donnees.anciennesDonnees.meteoInSitu).includes(file)" >
                    {{ file.filename }}
                    <v-icon style="font-size: medium;" @click="removeOld(index, 'meteoInSitu')"> mdi-close</v-icon>
                    <br />
                </span>
                </span>
                <span id="fileName" v-for="(file, index) in donnees.nouvelleDonnees.meteoInSitu.value"
                    :key="index">
                    {{ file.name }}
                    <v-icon style="font-size: medium;" @click="remove(index, 'meteoInSitu')"> mdi-close</v-icon>
                    <br />
                </span>
            </div>
        </div>
        <div class="donnees">
            <div>{{ $t("_veillez_enter_les_donnees_du_compteur_Grid_") }} (.csv)</div>
            <div class="attachFiles">
                <input id="input4" accept=".csv" multiple type="file" @change="handleFileChange($event, 'compteur')">
                <label id="labelInput" class="file-chip" for="input4"> {{ $t('_choisir_un_fichier_') }}</label>
                <br>
                <label v-if="badFileFormat.compteur" style="color: red;">{{ $t('_choisir_un_fichier_csv_') }}</label>
                <span id="fileName" v-for="(file, index) in donnees.anciennesDonnees.compteur" :key="index">
                    <span v-if="visibleFiles(donnees.anciennesDonnees.compteur).includes(file)" >
                    {{ file.filename }}
                    <v-icon style="font-size: medium;" @click="removeOld(index, 'compteur')"> mdi-close</v-icon>
                    <br />
                </span>
                </span>
                <span id="fileName" v-for="(file, index) in donnees.nouvelleDonnees.compteur.value"
                    :key="index">
                    {{ file.name }}
                    <v-icon style="font-size: medium;" @click="remove(index, 'compteur')"> mdi-close</v-icon>
                    <br />
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import api from "@/api/api";
import backend from "@/api/backend";

export default {

    props: {
        initdonnees: {
            required: false,
        },
        install_id: {
            required: false,
        }
    },

    //pre rempli le formulaire avec les données deja enregistées
    async mounted() {
        if (this.initdonnees !== undefined && this.initdonnees !== null)
            this.donnees.nouvelleDonnees = this.initdonnees
        this.listeOnduleur = await api.get_inv_model()
        let fichiers = await backend.get_all_production_data_metadatas(this.install_id)
        for (var fichier in fichiers.data) {
            switch (fichiers.data[fichier].filetype) {
                case 0:
                    this.donnees.anciennesDonnees.prod.push(fichiers.data[fichier])
                    break
                case 1:
                    this.donnees.anciennesDonnees.meteoSatellites.push(fichiers.data[fichier])
                    break
                case 2:
                    this.donnees.anciennesDonnees.meteoInSitu.push(fichiers.data[fichier])
                    break
                case 3:
                    this.donnees.anciennesDonnees.compteur.push(fichiers.data[fichier])
                    break
            }

        }
    },

    data() {
        return {
            fileList: [],
            donnees: {
                "anciennesDonnees": {
                    "prod": [],
                    "meteoSatellites": [],
                    "meteoInSitu": [],
                    "compteur": [],
                },
                "nouvelleDonnees": {
                    "prod": {
                        "value": [],
                        "required": true,
                    },
                    "meteoSatellites": {
                        "value": [],
                        "required": false,
                    },
                    "meteoInSitu": {
                        "value": [],
                        "required": false,
                    },
                    "compteur": {
                        "value": [],
                        "required": false,
                    },
                },
            },
            badFileFormat: {
                'prod': false,
                "meteoSatellites": false,
                "meteoInSitu": false,
                "compteur": false
            },
        }
    },

    methods: {
        // here l'ajout de fichier en verifiant leur type
        handleFileChange(event, dest) {
            const files = Array.from(event.target.files);
            for (var index in files) {
                if (files[index].type !== "text/csv" && files[index].type !== "application/vnd.ms-excel"){
                    this.badFileFormat[dest] = true
                    event.target.value = ""
                }
                else if (this.donnees.nouvelleDonnees[dest].value.indexOf(files[index]) === -1) {
                    this.badFileFormat[dest] = false
                    this.donnees.nouvelleDonnees[dest].value.push(files[index])
                }
                else {
                    this.badFileFormat[dest] = false
                }
                
            }
        },

        //supprime un fichier ajouté cette fois
        remove(index, dest) {
            this.donnees.nouvelleDonnees[dest].value.splice(index, 1)
        },
        //supprime un fichier ajouté precedement en vidant tous ses champs sauf id
        removeOld(index, dest) {
            for (var champ in this.donnees.anciennesDonnees[dest][index])
                if (champ !== "id"){
                    this.donnees.anciennesDonnees[dest][index][champ] = ""
                }
        },
        //Donne les fichier a afficher 
        visibleFiles(files){
            return files.filter(file => file.created_at!=='');
        }
    },

    watch: {
        donnees: {
            //Si il y a au moins un fichier par type de fichier obliatoire, autoriser la validation
            handler() {
                let complete = true
                for (var champs in this.donnees.nouvelleDonnees) {
                    if (this.donnees.nouvelleDonnees[champs].required === true)
                        if (this.donnees.nouvelleDonnees[champs].value.length === 0) {
                            let tempComplete = false
                            for (var files in this.donnees.anciennesDonnees[champs]) {
                                if (this.donnees.anciennesDonnees[champs][files].created_at !== "")
                                    tempComplete = true
                            }
                            complete=tempComplete

                            if (this.donnees.anciennesDonnees[champs].length === 0)
                                complete = false
                        }
                }
                var onlyValues = {}
                for (var champ in this.donnees.nouvelleDonnees) {
                    onlyValues[champ] = {}
                    onlyValues[champ].value = []
                    onlyValues[champ].value = this.donnees.nouvelleDonnees[champ].value
                }
                let final = { "anciennesDonnees": this.donnees.anciennesDonnees, "nouvelleDonnees": onlyValues }
                this.$emit("answer", final)
                if (complete === true) {

                    this.$emit("enable")
                }
                else
                    this.$emit("disable")

            },
            deep: true
        }
    }
}

</script>

<style scoped>
.file-chip {
    padding-left: 1vmax;
    padding-right: 1vmax;
    border-radius: 16px;
    background-color: #8096f6c5;
    color: black;
    font-size: 2vh;
    cursor: pointer;
    transition: background-color 0.3s;
}

#fileName {
    background-color: #EAEAEA;
    font-size: 2vh;
}

input[type="file"] {
    display: none;
}

.donnees {
    margin-bottom: 5vh;
}
</style>